import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-base" data-id="element-67" data-mp="bkea9ifiuoe4">
      <div className="max-w-6xl mx-auto" data-id="element-68" data-mp="bil7ie814obe">
        <div className="text-center mb-16" data-id="element-69" data-mp="gakz9jdy4aww">
          <p className="text-accent font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-70" data-mp="gbmmsnc5epvi">
            Coach stories
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-extrabold text-ink" data-id="element-71" data-mp="lc223kfzq7g4">
            What boxing coaches are saying
          </h2>
          <p className="text-sm text-graphite-light mt-4" data-id="element-72" data-mp="uadxs0vprvff">
            Use verified customer reviews in this section.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-73" data-mp="z8xixz2hh36q">
          {extendedTestimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-paper border border-silver-light p-8 rounded-2xl relative flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-74" data-mp="310twfe87on45" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-accent/15" size={48} aria-hidden="true" data-id="element-75" data-mp="3vq0ayyngiydv" />
              <p className="text-xs font-display font-bold uppercase tracking-widest text-accent mb-4" data-id="element-76" data-mp="3rp6p0atkrtnm">
                {testimonial.name}
              </p>
              <p className="text-graphite mb-8 relative z-10 leading-relaxed flex-grow" data-id="element-77" data-mp="3hqr0mflxmyht">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-78" data-mp="2bbgiyyiwavbc">
                <div className="w-12 h-12 rounded-full bg-ink flex items-center justify-center text-white font-display font-bold text-lg shrink-0" data-id="element-79" data-mp="26asrkbqr8cgl">
                  {testimonial.initials}
                </div>
                <div className="text-xs text-graphite-light" data-id="element-80" data-mp="2cq14cbsi9i7c">{testimonial.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}